import * as __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3ba00c2d__ from "../../../variants/tv.js";
const radioSizeVariants = {
    16: {
        labelSlot: 'text-body3',
        radioRoot: 'w-4 h-4',
        radioIndicator: 'before:w-[6px] before:h-[6px]'
    },
    20: {
        labelSlot: 'text-body2',
        radioRoot: 'w-4 h-4',
        radioIndicator: 'before:w-[8px] before:h-[8px]'
    },
    24: {
        labelSlot: 'text-body1',
        radioRoot: 'w-6 h-6',
        radioIndicator: 'before:w-[10px] before:h-[10px]'
    }
};
const radioSizes = Object.keys(radioSizeVariants);
const RadioEmphasisVariants = {
    regular: {
        labelSlot: 'text-primary-13 has-disabled:text-primary-6',
        radioRoot: `
      bg-primary-1 border border-primary-6 
      hover:border-primary-10 focus-visible:outline-primary-8

      data-checked:bg-primary-8 data-checked:border-primary-8 
      hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9   

      disabled:bg-primary-2 disabled:border-primary-5 disabled:hover:border-primary-5
      disabled:data-checked:bg-primary-2  disabled:data-checked:border-primary-2
      disabled:hover:data-checked:bg-primary-2 disabled:hover:data-checked:border-primary-2
    `,
        radioIndicator: 'data-checked:before:bg-primary-1 data-disabled:data-checked:before:bg-primary-6',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    },
    medium: {
        labelSlot: 'text-primary-13 has-disabled:text-primary-6',
        radioRoot: `
      bg-primary-1/60 border border-primary-6 
      hover:border-primary-10 focus-visible:outline-primary-8

      data-checked:bg-primary-8 data-checked:border-primary-8 
      hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9

      disabled:bg-primary-1/60 disabled:border-primary-5 disabled:hover:border-primary-5
      disabled:data-checked:bg-primary-1/60 disabled:data-checked:border-primary-1/60
      disabled:hover:data-checked:bg-primary-1/60 disabled:hover:data-checked:border-primary-1/60
    `,
        radioIndicator: 'data-checked:before:bg-primary-1 data-disabled:data-checked:before:bg-primary-6',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    },
    bold: {
        labelSlot: 'text-primary-1 has-disabled:text-primary-1/40',
        radioRoot: `
      bg-primary-1/20 border border-primary-1/40 
      hover:border-primary-1 focus-visible:outline-primary-1

      data-checked:bg-primary-1 data-checked:border-primary-1
      hover:data-checked:bg-primary-1/80  hover:data-checked:border-primary-1/80

      disabled:bg-primary-1/20 disabled:border-primary-1/20 disabled:hover:border-primary-1/20
      disabled:data-checked:bg-primary-1/20 disabled:data-checked:border-primary-1/20
      disabled:hover:data-checked:bg-primary-1/20 disabled:hover:data-checked:border-primary-1/20
    `,
        radioIndicator: 'data-checked:before:bg-primary-8 data-disabled:data-checked:before:bg-primary-1/40',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    }
};
const RadioStateVariants = {
    enabled: {
        containerSlot: 'group',
        labelSlot: 'hover:before:bg-primary-2 relative cursor-pointer before:absolute before:inset-0 before:-z-[1] before:rounded-xl before:border-0 before:transition before:duration-300',
        helperSlot: 'hover:before:bg-primary-2 text-primary-13 relative cursor-pointer before:absolute before:inset-0 before:-z-[1] before:-m-2 before:rounded-xl before:border-0 before:transition before:duration-300',
        textRightSlot: 'cursor-pointer text-primary-10'
    },
    disabled: {
        containerSlot: 'group disabled:cursor-not-allowed',
        labelSlot: 'has-disabled:cursor-not-allowed',
        helperSlot: 'text-primary-6 has-disabled:cursor-not-allowed',
        textRightSlot: 'text-primary-6 has-disabled:cursor-not-allowed',
        imageSlot: 'has-disabled:cursor-not-allowed'
    }
};
const radioEmphases = Object.keys(RadioEmphasisVariants);
const radioButtonVariants = (0, __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3ba00c2d__.tv)({
    slots: {
        containerSlot: 'has-disabled:cursor-not-allowed flex flex-1 flex-col items-start text-left',
        labelSlot: 'has-disabled:cursor-not-allowed hover:bg-primary-2 items-normal flex items-center gap-2 rounded-md border-4 border-solid border-transparent text-left leading-tight',
        radioRoot: 'hover:shadow-input-hover data-checked:transition inline-flex cursor-pointer items-center justify-center rounded-full transition focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:shadow-none',
        radioIndicator: 'data-unchecked:hidden data-checked:transition flex transition before:rounded-full',
        iconSlot: 'no-underline transition hover:no-underline group-hover:no-underline',
        helperSlot: 'has-disabled:cursor-not-allowed text-body3 display-block items-normal flex w-full text-left leading-tight',
        textRightSlot: 'has-disabled:cursor-not-allowed text-body3 text-primary-10 flex justify-end pt-0',
        imageSlot: 'has-disabled:cursor-not-allowed inline-block self-center overflow-hidden bg-gray-50'
    },
    variants: {
        emphasis: RadioEmphasisVariants,
        size: radioSizeVariants,
        state: RadioStateVariants,
        isRadioGroup: {
            true: {}
        },
        layout: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            isRadioGroup: true,
            layout: 'vertical',
            class: {
                labelSlot: 'w-full py-1'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        size: '20',
        state: 'enabled',
        isRadioGroup: false,
        layout: 'vertical'
    }
});
export { RadioEmphasisVariants, RadioStateVariants, radioButtonVariants, radioEmphases, radioSizeVariants, radioSizes };
